import { __decorate } from "tslib";
import { getSubErrorsAt } from '@jsonforms/core';
import { html, css, observable, customElement, FASTElement, repeat, ref, } from '@microsoft/fast-element';
export const StepperWrapperRendererTemplate = (prefix = 'zero') => html `
  <template>
    <${prefix}-stepper 
      class="tabs-container" 
      ${ref('stepper')} 
      orientation="${(x) => {
    var _a;
    return ((_a = x.control.uischema.options) === null || _a === void 0 ? void 0 : _a.orientation)
        ? x.control.uischema.options.orientation
        : 'vertical';
}}"
      @next-step=${(x) => x.nextStep()}
      @validation-success=${(x) => x.resetValidation()} 
      @submit=${(x) => x.submit()} 
      :validation=${(x) => x.validation}>
      ${repeat((x) => x.control.uischema.elements, html `
          <${prefix}-stepper-tab class="tab-control">${(x, ctx) => { var _a; return (_a = x.label) !== null && _a !== void 0 ? _a : `Step ${ctx.index + 1}`; }}</${prefix}-stepper-tab>
        `, { positioning: true })}
      ${repeat((x) => x.control.uischema.elements, html `
          <${prefix}-stepper-tab-panel class="tab-panel-control">
            ${repeat((x) => x.options.childElements, html `
                <dispatch-renderer
                  ?submitted=${(x, ctx) => ctx.parentContext.parent.form.submitted}
                  :dispatch=${(x, ctx) => ctx.parentContext.parent.form.dispatch}
                  :jsonforms=${(x, ctx) => ctx.parentContext.parent.form.jsonforms}
                  :props=${(x, ctx) => ({
    uischema: x,
    schema: ctx.parentContext.parent.control.schema,
    renderers: ctx.parentContext.parent.control.renderers,
    path: ctx.parentContext.parent.control.path,
    enabled: ctx.parentContext.parent.control.enabled,
})}
                ></dispatch-renderer>
              `)}
          </${prefix}-stepper-tab-panel>
        `)}
    </${prefix}-stepper>
  </template>
`;
const styles = css `
  .tabs-container::part(stepper-panel-container) {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;
let StepperWrapper = class StepperWrapper extends FASTElement {
    connectedCallback() {
        super.connectedCallback();
        this.propertyNames = this.control.uischema.elements.map((element) => {
            const splitedScope = element.scope.split('/');
            return splitedScope.pop();
        });
        this.validation = this.propertyNames.map((propertyName, index) => ({
            isValid: () => getSubErrorsAt(propertyName, this.control.schema)(this.form).length === 0 &&
                Object.keys(this.control.data)[index] === propertyName,
        }));
    }
    submit() {
        this.$emit('submit-button-clicked');
    }
    nextStep() {
        this.$emit('submit-part');
        const currentProperty = this.propertyNames[this.stepper.activeTabIndex];
        if (!this.control.data[currentProperty]) {
            this.$emit('data-change', {
                data: Object.assign(Object.assign({}, this.control.data), { [currentProperty]: {} }),
            });
        }
    }
    resetValidation() {
        this.$emit('reset-form');
    }
};
__decorate([
    observable
], StepperWrapper.prototype, "form", void 0);
__decorate([
    observable
], StepperWrapper.prototype, "control", void 0);
__decorate([
    observable
], StepperWrapper.prototype, "validation", void 0);
__decorate([
    observable
], StepperWrapper.prototype, "stepper", void 0);
__decorate([
    observable
], StepperWrapper.prototype, "propertyNames", void 0);
StepperWrapper = __decorate([
    customElement({
        name: 'stepper-wrapper',
        styles,
        template: html `
    ${(x) => StepperWrapperRendererTemplate(x.form.jsonforms.prefix)}
  `,
    })
], StepperWrapper);
export { StepperWrapper };
